import { render, staticRenderFns } from "./LogoLogin.vue?vue&type=template&id=6ff18de2&"
import script from "./LogoLogin.vue?vue&type=script&lang=js&"
export * from "./LogoLogin.vue?vue&type=script&lang=js&"
import style0 from "./LogoLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports